// ----- Imports ----- //
import { countryGroups } from '@modules/internationalisation/countryGroup';
import { getCurrencyByCode, } from '@modules/internationalisation/currency';
import { getQueryParameter } from 'helpers/urls/url';
// ----- Functions ----- //
function fromCountryGroupId(countryGroupId) {
    const countryGroup = countryGroups[countryGroupId];
    return countryGroup.currency;
}
function fromString(s) {
    switch (s.toLowerCase()) {
        case 'gbp':
            return 'GBP';
        case 'usd':
            return 'USD';
        case 'aud':
            return 'AUD';
        case 'eur':
            return 'EUR';
        case 'nzd':
            return 'NZD';
        case 'cad':
            return 'CAD';
        default:
            return null;
    }
}
function fromQueryParameter() {
    const currency = getQueryParameter('currency');
    if (currency) {
        return fromString(currency);
    }
    return null;
}
function detect(countryGroup) {
    return fromQueryParameter() ?? fromCountryGroupId(countryGroup);
}
const glyph = (c) => getCurrencyByCode(c).glyph;
const extendedGlyph = (c) => getCurrencyByCode(c).extendedGlyph;
// ----- Exports ----- //
export { detect, fromCountryGroupId, glyph, extendedGlyph };
